import { paths } from '@mc/paths'
import { EventTypes, getPageSource, track, Locations } from '@mc/track-event'

export const trackPrimaryCtaClick = ({
  action,
  location,
}: {
  action: string
  location: typeof Locations.STICKY_FOOTER | typeof Locations.HERO
}) => {
  track(EventTypes.PURCHASE_CLICK, {
    active_annual_pass: false,
    page_source: getPageSource(),
    page_path: window.location.pathname,
    type: 'all-access-pass',
    class: 'annual-pass',
    href: paths.checkout,
    location,
    action,
  })
}
